import Select from "react-select";

/**
 * El desplegable de toda la app.
 *
 * POR QUÉ EXISTE. react-select dibuja el menú DENTRO del campo. Si algún
 * contenedor de arriba tiene scroll propio —y en esta app casi todos lo
 * tienen: el modal, la ficha, el paso a paso— el menú queda encerrado ahí y
 * se ve una sola opción dentro de una cajita con scroll, en vez de la lista.
 *
 * `menuPortalTarget` lo saca del contenedor y lo cuelga del <body>, así se
 * abre por encima de todo. `menuPosition: fixed` es lo que lo mantiene pegado
 * al campo cuando ese contenedor se scrollea.
 *
 * Y `classNamePrefix` va acá y no en cada llamada porque de eso dependen los
 * estilos del menú: sin el prefijo, react-select usa sus clases generadas y el
 * menú vuelve a salir blanco con el texto blanco en tema oscuro. Ya había un
 * desplegable en la app al que se le había olvidado.
 */
const SelectBase = (props) => (
  <Select
    classNamePrefix="react-select"
    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
    menuPosition="fixed"
    {...props}
  />
);

export default SelectBase;
